import styled from 'styled-components';

export const Component = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 350px;
`;